import React from 'react';
import { Button, Container, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import './Contact.css';
const Contact = () => {
    return (
      <>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
        <Container>
      <div style={{display: 'flex', justifyContent: 'center', color:"#067a75"}}>
      <Grid item xs={12} md={6}>
        <Typography variant="h4" sx={{color:'#fff'}}>Want to Work With me?</Typography>
        {/* <div className="border-skill-bottom"></div> */}
          <Typography variant="h6">I am looking for a team where I will show my ambition and passion
            also produce great value for them.
            Contact me through my email or any social media. 
            I would be happy to have a touch with you.
          </Typography>
          <br/>
         <Link to="/Contacts_us"> 
         <main>
	<button  className='contact_button'>Say Hello</button>
</main></Link>
         <br/>
      <br/>
      <br/>
      <br/>
      <br/>
        </Grid>
      </div>
        </Container>
        </>
    );
};

export default Contact;